/**
 * Utility functions for handling board IDs and keys
 * Provides backward compatibility for old URLs using numeric board IDs
 */

/**
 * Check if a board ID is numeric (old format) or a string key (new format)
 * @param {string|number} id - Board ID or key to check
 * @returns {boolean} - True if the ID is in the old numeric format
 */
export const isNumericBoardId = (id) => {
  // Check if the ID is a number or a string that can be parsed as a number
  return !isNaN(parseInt(id)) && id.toString() === parseInt(id).toString();
};

/**
 * Convert a numeric board ID to its corresponding board key
 * @param {Array} boards - List of boards from the API
 * @param {number} numericId - Numeric board ID to convert
 * @returns {string|null} - The board key if found, or null if not found
 */
export const getBoardKeyFromNumericId = (boards, numericId) => {
  if (!boards || !Array.isArray(boards)) return null;
  
  const board = boards.find(board => board.board_id === parseInt(numericId));
  return board ? board.key : null;
};

/**
 * Get board ID from key for internal usage
 * @param {Array} boards - List of boards from the API
 * @param {string} key - Board key to find
 * @returns {number|null} - The board ID if found, or null if not found
 */
export const getBoardIdFromKey = (boards, key) => {
  if (!boards || !Array.isArray(boards)) return null;
  
  const board = boards.find(board => board.key === key);
  return board ? board.board_id : null;
};